import { CardPage } from "../../components/atoms";
import {
  variantPageCardsGermline,
  variantPageCardsSomatic,
  variantPageCardsSomaticNonTp53,
  transcriptPageCards,
  positionPageCards,
  cnvPageCards,
} from "../../components/cards/cards";

import { genePageCards } from "../../components/cards/geneCards";
import async from "../../HOC/asyncComponent";
import store from "../../state/store";

const SOMATIC = "somatic";
const GERMLINE = "germline";

const nonCardPages = {
  article: {
    page: async(() => import("../article/ArticlePage")),
  },
  disease: {
    page: async(() => import("../disease/DiseasePage")),
  },
  phenotype: {
    page: async(() => import("../phenotype/PhenotypePage")),
  },
  favorites: {
    page: async(() => import("../favorites/FavoritesPage")),
  },
  history: {
    page: async(() => import("../history/HistoryPage")),
  },
  profile: {
    page: async(() => import("../profile/ProfilePage")),
  },
  messages: {
    page: async(() => import("../messages/Chat/MessagesPage")),
  },
  notifications: {
    page: async(() => import("../Notifications/NotificationsPage")),
  },
  "search-results": {
    page: async(() => import("../search-results/SearchPage")),
  },
  "single-read": {
    page: async(() => import("../single-reads/SingleReadsContainer")),
  },
  "varsome-pubmed": {
    page: async(() => import("../pubmed/PubmedPage")),
  },
  "update-log": {
    page: async(() => import("../update-log/UpdateLogPage")),
  },
  "community-contributions": {
    page: async(() => import("../community-contributions/CommunityPage")),
  },
  "account-settings": {
    page: async(() => import("../profile/AccountPage")),
  },
  "clinvar-submissions": {
    page: async(() => import("../clinvar-submissions/ClinvarSubmissionsPage")),
  },
};

const pageDict = {
  gene: {
    page: CardPage,
    cards: genePageCards,
  },
  transcript: {
    page: CardPage,
    cards: transcriptPageCards,
  },
  position: {
    page: CardPage,
    cards: positionPageCards,
  },
  cnv: {
    page: CardPage,
    cards: cnvPageCards,
  },
};

export function resolvePage(queryType, variantQueryMode, isTP53) {
  const { isCosmicDisabled } = store.getState();

  if (nonCardPages[queryType]) {
    return nonCardPages[queryType];
  }

  if (pageDict[queryType]) {
    // Remove CGC(cancer gene census) card if cosmic is disabled
    if (isCosmicDisabled && queryType === "gene") {
      const dict = pageDict[queryType];
      return {
        page: dict.page,
        cards: dict.cards.filter(({ id }) => id !== "cancerGeneCensus"),
      };
    }
    return pageDict[queryType];
  }

  if (variantQueryMode === SOMATIC) {
    const cards = isTP53
      ? variantPageCardsSomatic
      : variantPageCardsSomaticNonTp53;
    if (isCosmicDisabled) {
      const cardsNoCosmic = cards.filter(
        (x) => x.id !== "cancerSamplesCOSMICLicensed"
      );
      return { cards: cardsNoCosmic, page: CardPage };
    }
    return { cards, page: CardPage };
  }

  if (variantQueryMode === GERMLINE) {
    return { cards: variantPageCardsGermline, page: CardPage };
  }

  return { cards: variantPageCardsGermline, page: CardPage };
}
